<template>
	<div>
		<iframe
			:src=iframeLink
			frameborder="0"
			style="
				overflow: hidden;
				overflow-x: hidden;
				overflow-y: hidden;
				height: 80%;
				width: 80%;
				position: absolute;
			"
			height="150%"
			width="150%"
		></iframe>
	</div>
</template>
<script>
export default {
	data() {
		return {
			iframeLink: 'https://report.cloubit.com/public-dashboards/93a112a39c94408eb58168f4e64a1798',
		};
	},
	
};
</script>